const o = (n) => {
  const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n);
  return r ? {
    r: parseInt(r[1], 16),
    g: parseInt(r[2], 16),
    b: parseInt(r[3], 16)
  } : null;
}, g = (n, r = 1) => {
  const t = o(n);
  if (!t)
    return null;
  const { r: e, g: s, b: a } = t;
  return `rgba(${e},${s},${a},${r})`;
};
export {
  o as hexToRgb,
  g as hexToRgbaString
};
//# sourceMappingURL=colors.es.js.map
